export const colorsList = [
  'stoneGray',
  'blueMoon',
  'brilliantBlue',
  'midnightBlue',
  'blackInk',
  'purpleMist',
  'pinkFlamingo',
  'electricOrange',
  'rubyRed',
  'orangeSunrise',
  'springGreen',
  'turquoiseWater',
] as const;
export type Color = typeof colorsList[number];

export const defaultColor = colorsList[1];

// ----------------
// NOTE: MAKE SURE TO UPDATE WHITELIST IN /tailwind.config.js IF FOLLOWING LIST IS UPDATED!
// ----------------
export const colors = {
  stoneGray: {
    bg: 'gray-500',
    fg: 'black',
  },
  blueMoon: {
    bg: 'blue-200',
    fg: 'black',
  },
  brilliantBlue: {
    bg: 'blue-500',
    fg: 'white',
  },
  midnightBlue: {
    bg: 'blue-700',
    fg: 'white',
  },
  blackInk: {
    bg: 'blue-900',
    fg: 'white',
  },
  purpleMist: {
    bg: 'purple-300',
    fg: 'black',
  },
  pinkFlamingo: {
    bg: 'red-300',
    fg: 'black',
  },
  electricOrange: {
    bg: 'orange-500',
    fg: 'black',
  },
  rubyRed: {
    bg: 'red-700',
    fg: 'white',
  },
  orangeSunrise: {
    bg: 'yellow-500',
    fg: 'black',
  },
  springGreen: {
    bg: 'green-300',
    fg: 'black',
  },
  turquoiseWater: {
    bg: 'teal-300',
    fg: 'black',
  },
};
